import React, { useState, forwardRef } from "react";
// import video from "../assets/placeholder.mp4";
import AP from "../assets/AP_01.gif";
import APi from "../assets/AP_01.jpg";

import FF from "../assets/FF_01.gif";
import FFi from "../assets/FF_01.jpg";

import PT from "../assets/PT_01.gif";
import PTi from "../assets/PT_01.jpg";

import SP from "../assets/SP_01.gif";
import SPi from "../assets/SP_01.jpg";

import SS from "../assets/SS_01.gif";
import SSi from "../assets/SS_01.jpg";

import MW from "../assets/MW_01.gif";
import MWi from "../assets/MW_01.jpg";

import GD from "../assets/GD_01.gif";
import GDi from "../assets/GD_01.jpg";

import AC from "../assets/AC_01.gif";
import ACi from "../assets/AC_0001.jpg";

import CP from "../assets/CP.gif";
import CPi from "../assets/CP.jpg";

import GC from "../assets/GC_01.gif";
import GCi from "../assets/GC_01.jpg";

import CDA from "../assets/Onfinance_CdA.jpg";

import Card from "./Card";

const Company = forwardRef((props, ref) => {
  const [tab, setTab] = useState("team");
  return (
    <>
      <p id="Company" ref={ref}>
        {props.text.subParagraph}
      </p>
      <ul>
        {props.text.bullets.map((bullet, index) => (
          <li
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span
              style={{
                backgroundColor: "#f48a1e",
                marginRight: "10px",
                borderRadius: "50%",
                display: "inline-block",
                width: "4px",
                height: "4px",
              }}
            />

            <p
              style={{
                color: "#172242",
                margin: 0,
              }}
            >
              {bullet}
            </p>
          </li>
        ))}
      </ul>
      <br />
      {/* <div
        style={{
          display: "flex",
          gap: "32px",
        }}
      >
        <span
          className="buttonTab"
          style={{ color: tab == "team" ? "#f48a1e" : "#172242" }}
          onClick={() => {
            setTab("team");
          }}
        >
          Team
        </span>

        <span
          className="buttonTab"
          style={{ color: tab == "board" ? "#f48a1e" : "#172242" }}
          onClick={() => {
            setTab("board");
          }}
        >
          {props.text.BoardOfDirectors.title}
        </span>
      </div> */}
      {tab == "team" ? (
        <ul className="ulCards">
          <Card
            name="Stefano Pezzoli"
            position="The Playmaker"
            deg="Lic. Oec. HSG"
            gif={SP}
            still={SPi}
          />
          <br></br>
          <Card
            name="Stefano Sampietro"
            position="The Quant Mind"
            deg="Phd"
            gif={SS}
            still={SSi}
          />
          <Card
            name="Paolo Tenconi"
            position="The Mind Behind (the platform)"
            deg="Phd"
            gif={PT}
            still={PTi}
          />
          <Card
            name="Marcello Waller"
            position="The Pricing Machine"
            deg="MscIBD"
            gif={MW}
            still={MWi}
          />
          <Card
            name="Andrea Ciocca"
            position="The Trader Corner"
            deg="MSc Finance"
            gif={AC}
            still={ACi}
          />

          <Card
            name="Camillo Pezzoli"
            position="The Head AMC Management"
            deg="BSc Economics"
            gif={CP}
            still={CPi}
          />

          <Card
            name="Gaia Cansani"
            position="The Head Admin & Compliance"
            deg=""
            gif={GC}
            still={GCi}
          />

          <Card
            name="Andreas Passano"
            position="The Financial Analyst"
            deg="MSc Finance"
            gif={AP}
            still={APi}
          />
          <Card
            name="Giancarlo D’Oria"
            position="The Fund corner"
            // deg='"---"'
            gif={GD}
            still={GDi}
          />
        </ul>
      ) : (
        <>
          <div className="ulCards">
            <div className="card">
              <img src={CDA} style={{ width: "100%" }} />
            </div>
          </div>

          <p>
            {props.text.BoardOfDirectors.left} <br />
            <div
              dangerouslySetInnerHTML={{
                __html: props.text.BoardOfDirectors.names,
              }}
            />
          </p>
        </>
      )}
      <br />
      <br /> <br />
      <br /> <br />
    </>
  );
});
export default Company;
